// Keep aligned with ecommerce-service StoreBillingConstants.STORE_CREATION_CREDITS.
export const STORE_CREATION_CREDITS = 200;
